import React from 'react';
import './Opinion.css';

export default function Opinion() {
  return (
    <div className="opinion" id='opinion'>
      <div className='lol'>
      <h2 className="head">أراء عملاؤنا</h2>

      </div>
      <div className="main">
        <div className="right">
          <div className="one">
            <div className="review-card">
              <p className="review-text">
مش هقولك غير انك دكتور المعجزات يعني اكبر دكتور علي مستوي الجمهوريه عن تجربه 16سنه ربنا يباركلك في صحتك ويخليي  يك لكل مشتاق ومحروم من الضحكه الحلوه وكلمة ماما والله الدكتور مصطفي بعد ربنا وما تتعبيش نفسك

</p>
<div className='name'>
  <p>أ / موده خالد</p>
  <p>2024</p>
</div>
            </div>
          </div>
          <div className="one">
            <div className="review-card">
              <p className="review-text">
              دكتور مصطفي كل كلام الدنيا مش هيوفي حضرتك حقك حضرتك ع المستوي الشخصي المعني الحقيقي لأبن الأصول والمحترم الخلوق ع المستوي العلمي فحضرتك فمكانه تانيه خالص يارب دائما متألق ومبدع فمجالك وربنا يسعدك ويبارك فعمرك وعلمك وعملك وذريتك زي ما أسعدتنا دكتوري الغالي على قلوبنا أحبك فالله
</p>
<div className='name'>
  <p>أ / ايمان علي</p>
  <p>2024</p>
</div>
            </div>
          </div>
        </div>
        <div className="left">
          <div className="one">
            <div className="review-card">
              <p className="review-text">
              ربنا يكرمك ويرزقك من واسع فضله يارب انسان محترم متربي ابن ناس بيحس بالمرضي وعندو ضمير ماشاءالله تبارك الله عالم فعلا في شغله ومتواضع جدا اسال الله العظيم ان يبارك فيك وفي علمك واولادك وان يرزقك من واسع فضله اللهم امين يارب العالمين
</p>
<div className='name'>
  <p>أ / احمد عامر</p>
  <p>2024</p>
</div>
            </div>
          </div>
          <div className="one">
            <div className="review-card">
              <p className="review-text">
              الحمد لله انتهت رحلة وهنٍ على وهن وأهداني الله عُمر و عليّ على يد دكتور مصطفي بعد ثلاث سنوات من المتابعات والحقن المجهري المتكرر الفاشل وغيره مع أطباء كُثر ، أقل ما يقال في حقه أنه دكتور الإنسانية الخلوق أفاض الله عليكَ بواسع فضله
وزادك من خيري الدنيا والآخرة وچعل الله عملك في ميزان حسناتك، وجعلك دائما البسمة والبهجة والفرحة التي تكمل جميع الأسر الفاقدة لهما. 
              </p>
              <div className='name'>
  <p>أ / اميره حسين</p>
  <p>2024</p>
</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}